import { useState } from "react";
import { toast } from "sonner";
import { Loader2, Square } from "lucide-react";
import { Button } from "@/components/ui/button";
import { errMsg } from "@/lib/api";

// Stops a running AI operation server side: no new provider call is started, completed work stays saved.
export default function StopButton({ api, projectId, opId, label = "Interrompi", testid = "ai-stop-btn", className = "" }) {
  const [busy, setBusy] = useState(false);
  const stop = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(opId ? `/ai-ops/${opId}/cancel` : `/projects/${projectId}/ai-ops/cancel`);
      toast.message("Interruzione richiesta", {
        description: data.inflight_calls
          ? "Nessuna nuova chiamata AI verrà avviata. La chiamata già inviata al provider potrebbe essere addebitata comunque."
          : "Nessuna nuova chiamata AI verrà avviata. Il lavoro già completato resta salvato.",
      });
    } catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };
  return (
    <Button size="sm" variant="outline" onClick={stop} disabled={busy} data-testid={testid}
      className={`h-8 border-red-200 text-red-700 hover:bg-red-50 hover:text-red-800 ${className}`}>
      {busy ? <Loader2 size={13} className="mr-1.5 animate-spin" /> : <Square size={11} className="mr-1.5 fill-current" />}
      {busy ? "Interruzione…" : label}
    </Button>
  );
}
